<template>
  <v-layout column align-center id="source-carousel-container">
    <v-layout id="carousel-action-btn-container" flex column align-center>
      <span>
        {{ $t('sourceCarousel.sourcesLabel') }}
      </span>
      <span slot="activator" @click="handleHelpMeChooseClick" class="action-btn action-btn-rounded">
        <v-tooltip left>
          <v-icon class="carousel-action-btn-icon" slot="activator">question_mark</v-icon>
          <span>{{ $t('sourceCarousel.actionBtn.helpMeChoose') }}</span>
        </v-tooltip>
      </span>
      <span class="divider-line divider-line-blue"></span>
    </v-layout>
    <v-flex class="source-item-container source-item-container-newTab custom-scrollbar" @scroll="scrollListener">
      <!-- Used to add proper styling to top Element -->
      <label class=notSelected></label>
      <source-name-component
        v-for="source in sources"
        v-model="selectedSource"
        :source="source"
        :key="source.name"
        @handleTargetEngineClick="$emit('handleTargetEngineClick', $event)"
      ></source-name-component>
    </v-flex>
    <v-flex>
      <transition>
        <v-icon v-if="isVisibleScrollIcon">keyboard_arrow_down</v-icon>
      </transition>
    </v-flex>
  </v-layout>
</template>
<script>
import {DEFAULT_ENGINE, POSSIBLE_ENGINES} from '../../../utils/search-engines'
import { helpMeChooseUrl } from '../../../utils/constants'
import '../../../style/_variables.scss'
import SourceNameComponent from './SourceNameComponent'

export default {
  name: 'SourceCarousel',
  components: {SourceNameComponent},
  data () {
    return {
      sources: POSSIBLE_ENGINES,
      engineName: DEFAULT_ENGINE.name,
      selectedSource: this.engineName,
      helpMeChooseUrl: helpMeChooseUrl,
      rotateReload: false,
      isVisibleScrollIcon: true
    }
  },
  created () {
    this.possibleEngines.map(engine => {
      if (engine.name === this.selectedSource) {
        engine.selected = true
      }
    })
  },
  methods: {
    handleHelpMeChooseClick () {
      window.open(helpMeChooseUrl, '_blank').focus()
    },
    handleReloadClick () {
      this.rotateReload = true
      const resetRotate = () => {
        this.rotateReload = false
      }
      setTimeout(resetRotate, 1500)
    },
    scrollListener (e) {
      this.isVisibleScrollIcon = e.target.offsetHeight + e.target.scrollTop < e.target.scrollHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

#source-carousel-container {
  height: 100%;
}
#carousel-action-btn-container {
  margin-top: $length-small-m;
  font-weight: 700;
  width: 75px;
  background-color: $bg-primary;
}
.carousel-action-btn-icon {
  font-size: 20px;
}
.round-item, .action-btn {
  border-radius: 50%;
  width: 35px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: $length-small-l 0;
  &-rounded, &-squared {
    border: $length-small-s solid $black-900;
  }
  &-squared {
    border-radius: $length-small-xl;
  }
}

.source-item-container {
  width: 75px;
  &-iframe {

  }
  &-newTab {
    overflow-x: auto;
  }
}

.notSelected {
  border-radius: 40px 0 0 40px;
  position: relative;
  z-index: 10;
  background: $bg-primary;
}
.help-me-choose {
  &-container:hover {
    color: $blue-primary;
    text-decoration: underline;
    cursor: pointer;
    & > .help-me-choose-icon {
      color: $blue-primary;
    }
  }
  &-icon {
    font-size: 10px;
  }
}
.rotate {
  animation: rotation 1s
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(365deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/SourceCarousel.vue